import React, { useEffect } from 'react';
import { useText } from '../context/TextContext';
import { AdvancedButton } from './AdvancedButton';
import { AVATAR_SIZE } from '../utils/shared/constants';

interface Props {
    size?: 'sm'
    readonly?: boolean;
    logo?: string;
    onNewFile?: (file: File) => void;
    className?: string;
}

export default function OrganizationLogo(props: Props) {
    const { logo, onNewFile } = props;
    const texts = useText();

    const size = props.size === 'sm' ? AVATAR_SIZE.SM : AVATAR_SIZE.MD;

    const [logoSrc, setLogoSrc] = React.useState<string | undefined>(logo);

    useEffect(() => {
        setLogoSrc(logo);
    }, [logo]);

    const handleLogoClick = () => {
        const input = document.createElement('input');
        input.type = 'file';
        input.accept = 'image/*';
        input.onchange = (e) => {
            const file = (e.target as HTMLInputElement).files?.[0];
            if (file) {
                if (onNewFile) {
                    onNewFile(file);
                }
                const reader = new FileReader();
                reader.onload = () => {
                    setLogoSrc(reader.result as string);
                };
                reader.readAsDataURL(file);
            }
        };

        input.click();
    }

    return (
        <div className={`overflow-hidden center border rounded position-relative ${props.className || ''}`}
            style={{ width: size, height: size }}
            onClick={() => handleLogoClick()}
        >
            {logoSrc
                ? <img src={logoSrc} alt="Organization Logo" style={{ minWidth: '100%', minHeight: '100%' }} />
                : <i className="bi bi-image" style={{ fontSize: 24 }} />}
            {onNewFile && <AdvancedButton icon="bi-upload" size='sm' className='position-absolute w-100' variant="secondary" as="label"
                style={{ bottom: 0, right: 0, width: 'fit-content', padding: 5, fontSize: 12 }}
            >
                {logo ? texts.changeLogo : texts.uploadLogo}
            </AdvancedButton>}
        </div>
    );
}
